export default __webpack_public_path__ + "static/media/TradeValue.459f2750.svg";